module.exports = __webpack_public_path__ + "static/img/zuooo.aaac6b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zuooo.jpg
// module id = dWhD
// module chunks = 5